"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _atoms = require("../../../atoms");

var _utils = require("../../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const UserNav = ({
  userName,
  avatar
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "user-actions"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "avatar"
  }, avatar ? /*#__PURE__*/_react.default.createElement("img", {
    src: avatar,
    alt: userName
  }) : /*#__PURE__*/_react.default.createElement(_styles.StyledAvatar, {
    size: "28px",
    round: "28px",
    color: _atoms.theme.palette.brand.primary.charcoal,
    bgColor: _atoms.theme.palette.brand.primary.white
  }, userName && (0, _utils.initials)(userName))), /*#__PURE__*/_react.default.createElement("div", {
    className: "user-name"
  }, userName));
};

UserNav.propTypes = {
  userName: _propTypes.default.string,
  avatar: _propTypes.default.string
};

const UserAction = ({
  userName,
  avatar,
  userEmail,
  userNav
}) => {
  return /*#__PURE__*/_react.default.createElement(_styles.StyledUserAction, null, /*#__PURE__*/_react.default.createElement(_atoms.Popover, {
    showArrow: true,
    className: "profile",
    placement: "bottom",
    target: /*#__PURE__*/_react.default.createElement(UserNav, {
      userName: userName,
      avatar: avatar
    })
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledPopoverContent, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: avatar ? 'avatar' : ''
  }, /*#__PURE__*/_react.default.createElement("span", null, avatar ? /*#__PURE__*/_react.default.createElement("img", {
    src: avatar,
    alt: userName
  }) : /*#__PURE__*/_react.default.createElement(_styles.StyledAvatar, {
    size: "40px",
    round: "40px",
    color: _atoms.theme.palette.brand.primary.white,
    bgColor: _atoms.theme.palette.brand.primary.charcoal,
    fSize: "14px"
  }, userName && (0, _utils.initials)(userName)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement("strong", null, userName), /*#__PURE__*/_react.default.createElement("p", null, userEmail))), /*#__PURE__*/_react.default.createElement("ul", null, userNav && userNav.map((nav, id) => /*#__PURE__*/_react.default.createElement("li", {
    key: id
  }, /*#__PURE__*/_react.default.createElement(_atoms.Link, {
    href: nav.link,
    text: nav.label,
    type: "secondary",
    isLeft: true
  })))))));
};

UserAction.propTypes = {
  userNav: _propTypes.default.array,
  avatar: _propTypes.default.string,
  userName: _propTypes.default.string,
  userEmail: _propTypes.default.string
};

var _default = /*#__PURE__*/_react.default.memo(UserAction);

exports.default = _default;